import { GTMDataLayer } from 'adapters/types';

export const gtmId = 'GTM-P8QBWVM';

export const defaultGtmDataLayer: GTMDataLayer = {
  d_user_id: '',
  d_company_id: '',
  d_company_name: '',
  d_company_access: '',
  d_enterprise_id: '',
  d_department_id: '',
  d_user_roles: []
};
